module.exports = __webpack_public_path__ + "static/speaker6-50236657a78f71958cfaa0dc17acb310.jpg";